export var Routes = {
    intro: {
        index: 'intro.index',
    },
    auth: {
        login: 'auth.login',
        connect: 'auth.connect',
    },
};
